import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Box, CircularProgress } from "@material-ui/core";

import LandingPage from "../landingpage";

const backendUrl = () =>
  process.env.REACT_APP_BACKEND_URL || "https://api.floow.chat";

// A página do afiliado É a nossa página, com os botões de compra apontando
// para o checkout dele. Nada é copiado: mudou a nossa, mudou a dele.
const PaginaAfiliado = () => {
  const { slug } = useParams();
  const history = useHistory();

  const [carregando, setCarregando] = useState(true);
  const [afiliado, setAfiliado] = useState(null);

  useEffect(() => {
    fetch(`${backendUrl()}/affiliate/pagina/${slug}`)
      .then(r => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(dados => {
        setAfiliado(dados);
        setCarregando(false);
      })
      .catch(() => {
        // Apelido que não existe ou afiliação sem liberação: vai para a nossa.
        history.replace("/");
      });
  }, [slug, history]);

  if (carregando) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!afiliado) return null;

  return <LandingPage afiliado={afiliado} />;
};

export default PaginaAfiliado;
